import { Vector2 } from 'three';
import {
	BufferGeometry,
	Float32BufferAttribute,
	ShaderMaterial,
	UniformsUtils,
	Points,
	Vector3,
	OrthographicCamera
} from 'three';
import { Pass } from 'three/examples/jsm/postprocessing/Pass.js';

class FlyPointPass extends Pass {
    shader
	camera
	geometry
	uniforms
	material
	scene
	renderToScreen
	clear

	constructor( camera?, shader?, geometry? ) {

		super();

		this.shader = shader ? shader : {
			uniforms: {
				iTime: { value: 0 },
				iShift: { value: new Vector3() },
				iAlpha: { value: 0 },
				iAnimation: { value: new Vector3() },
				iResolution: { value: {
					x: window.innerWidth * window.devicePixelRatio,
					y: window.innerHeight * window.devicePixelRatio
				}}
			},
			vertexShader: `
				attribute float size;
				uniform float iTime;
				uniform vec3 iShift;
				uniform vec2 iResolution;
				uniform vec3 iAnimation;
				varying float transparency;
		
				vec3 warp3d(vec3 pos, float t) {
					float curv = 0.9, a = 1.9, b = 0.25, b2 = 0.03, c = 0.02;
					pos *= 2.;
					pos.x += curv * sin(c * t + a * pos.y) + t * b2;
					pos.y += curv * cos(c * t + a * pos.x);
					// pos.y += curv * sin(c * t + a * pos.z) + t * b2;
					pos.z += curv * cos(c * t + a * pos.y);
					pos.z += curv * sin(c * t + a * pos.x) + t * b;
					pos.z = abs( pos.z );
					// pos.x += curv * cos(c * t + a * pos.z);
					return pos.xyz;
				}

				void main() {
					vec3 v = warp3d(position, iTime);
					v = 3. * (2. * fract(v + iShift) - 1.) + iAnimation;

					vec4 vpos = modelViewMatrix * vec4(v, 1.);
					vec2 t = vec2(1);
					vec2 q = vec2(length(position.xy)-t.x,position.z);
					transparency = step(length(v), 3.);

					gl_PointSize = size * iResolution.y / 1000. / -vpos.z;
					gl_Position = projectionMatrix * vpos;
				}`,
			fragmentShader: `
				varying float transparency;
				uniform float iAlpha;

				void main() {
					vec3 color = vec3(.1, .9, .8) * .8;
					float tex = smoothstep(1., .3, length(2. * gl_PointCoord - 1.));
					gl_FragColor = vec4(tex * color, tex * transparency * iAlpha );
				}`
			}

    this.camera = camera ? camera : new OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );

		let pointGeometries = new BufferGeometry();

		if (!geometry) {
		  let pointPositions = [];
		  let pointSizes = [];
		  
		  for ( let i = 0; i < 200; i ++ ) {
				let x = 2 * Math.random() - 1;
				let y = 2 * Math.random() - 1;
				let z = 2 * Math.random() - 1;
		    pointPositions.push( x, y, z );
		    pointSizes.push(25 + 25 * Math.random());
		  }
		  
		  pointGeometries.setAttribute( 'position', new Float32BufferAttribute( pointPositions, 3 ) );
		  pointGeometries.setAttribute( 'size', new Float32BufferAttribute( pointSizes, 1 ) );
		}

    this.geometry = geometry ? geometry : pointGeometries;
		this.uniforms = UniformsUtils.clone( this.shader.uniforms );
    this.material = new ShaderMaterial( {
      vertexShader: this.shader.vertexShader,
      fragmentShader: this.shader.fragmentShader,
      uniforms: this.uniforms,
      defines: Object.assign( {}, this.shader.defines ),
      transparent: true
    } );
		this.material.stencil = false;

    this.scene = new Points(this.geometry, this.material)

	}

	render( renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {


		if ( this.renderToScreen ) {

			renderer.setRenderTarget( null );
      renderer.render( this.scene, this.camera );

		} else {

			renderer.setRenderTarget( writeBuffer );
			if ( this.clear ) renderer.clear( renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil );
			renderer.render( this.scene, this.camera  );

		}

	}

	update(t) {
		this.uniforms.iTime.value = t;
		this.uniforms.iShift.value.add(this.camera.position.clone().multiplyScalar(0.0022));
	}

}

export { FlyPointPass };